import styled from "styled-components";

const FooterCopyRightLink = styled.span`
    color: #ccc;
    border-left: 1px solid #ccc;
    margin-left: 15px;
    padding-left: 15px;
    > a {
        color: #ccc;
    }

    @media (max-width: 575px) {
        margin-left: 10px;
        border: none;
        padding: 0;
    }
`;
export default FooterCopyRightLink;
